import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import InstagramConnection from './InstagramConnection';
import FacebookConnection from './FacebookConnection';
import TikTokConnection from './TikTokConnection';
import './SocialSettings.css';

function SocialSettings() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);

  const flags = user?.feature_flags || {};
  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin' || user?.is_superuser;

  const canInstagram = isAdmin || (flags.can_connect_socials && flags.can_connect_instagram);
  const canFacebook = isAdmin || (flags.can_connect_socials && flags.can_connect_facebook);
  const canTikTok = isAdmin || (flags.can_connect_socials && flags.can_connect_tiktok);

  return (
    <div className="social-settings-container">
      <div className="page-header">
        <Link to="/" className="back-link">
          ← {t('common.back_to_dashboard')}
        </Link>
        <h1>{t('socialSettings.title', 'Social Media Accounts')}</h1>
        <p className="page-description">
          {t('socialSettings.description', 'Connect your social media accounts to enable automated content publishing and engagement.')}
        </p>
      </div>

      <div className="social-accounts-grid">
        {/* Instagram Section */}
        {canInstagram && <InstagramConnection />}

        {/* Facebook Page Section */}
        {canFacebook && <FacebookConnection />}

        {/* TikTok Section */}
        {canTikTok && <TikTokConnection />}

        {!canInstagram && !canFacebook && !canTikTok && (
          <div className="social-no-access">
            <span className="social-no-access-icon">🔒</span>
            <p>{t('socialSettings.no_access', 'No social platforms are enabled for your account. Contact your administrator to request access.')}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SocialSettings;
